const styles = () => ({
  messageWrapper: {
    marginTop: 50,
    textAlign: 'center',
  },
  buttonWrapper: {
    maxWidth: 250,
    margin: '0 auto',
  },
  messageBody: {
    maxWidth: 400,
    margin: '10px auto 50px auto',
  },
  container: {
    marginTop: 15,
  },
  buttonContainer: {
    textAlign: 'right',
    marginBottom: 20,
  },
  button: {
    margin: '0 0 10px 10px',
  },
})

export default styles



// WEBPACK FOOTER //
// ./src/sections/yours/styles.js